import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfressionalSubscriptionModel } from './models/subscription/professional-subscription.model';
import { PurchaseSubscriptionModel } from './models/utils/subscription';
import { SubscriptionPlanModel } from './models/subscription/subscription-plan.model';
import { BraintreePaymentRequest } from './models/subscription/braintree-payment-request.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private http: HttpClient) {}

  getBraintreePlans(): Observable<SubscriptionPlanModel[]> {
    return this.http
      .get(`/ws/professional/plan`)
      .pipe(map((response: any) => response.plans as SubscriptionPlanModel[]));
  }

  getBraintreePlan(plan_id: string, discountcode?: string): Observable<SubscriptionPlanModel> {
    return this.http
      .get(`/ws/professional/plan?plan_id=${plan_id}&discountcode=${discountcode}`)
      .pipe(map((response: any) => response.plan));
  }

  getBraintreeClientToken(): Observable<string> {
    return this.http
      .get('/ws/professional/customer')
      .pipe(map((response: any) => response.client_token));
  }

  getProfessionalSubscription(): Observable<ProfressionalSubscriptionModel> {
    return this.http
      .get('/ws/user/profile?version=2&subscription_hard_check=1')
      .pipe(map((response: any) => response.subscription as ProfressionalSubscriptionModel));
  }

  buyProfessionalSubscription(request: PurchaseSubscriptionModel): Observable<any> {
    return this.http.post('/ws/professional/subscribe', {
      ...request,
      subscription_intent: 'buy',
    });
  }

  updateProfessionalSubscription(request: BraintreePaymentRequest): Observable<any> {
    const { nonce, device_data } = request;
    return this.http.post('/ws/professional/subscribe', {
      payment_method_nonce: nonce,
      device_data: device_data,
      subscription_intent: 'update',
    });
  }

  cancelSubscription(): Observable<any> {
    return this.http.post('/ws/professional/cancel', {});
  }
}
